// extracted by mini-css-extract-plugin
export default {"closeIcon":"CloseIconButton_closeIcon__vdC10"};